<template>
  <span v-if="loggedIn" class="presence-selector" :class="'variant-' + variant">
    <el-popover
      ref="popover"
      placement="bottom"
      trigger="click"
      popper-class="presence-status-popper"
    >
      <ul class="presence-menu">
        <li
          v-for="opt in options"
          :key="opt.value"
          :class="{ active: normalized === opt.value }"
          @click="onPick(opt.value)"
        >
          {{ opt.label }}
        </li>
      </ul>
      <span slot="reference" class="presence-ref" @click.stop>
        <span class="presence-dot" :class="'dot-' + normalized" />
        <span class="presence-label">{{ displayLabel }}</span>
        <i class="el-icon-arrow-down el-icon--right" />
      </span>
    </el-popover>
  </span>
</template>

<script>
import { mapGetters } from 'vuex'
import { PRESENCE_OPTIONS, normalizePresenceStatus, presenceStatusLabel } from '@/utils/presence'

export default {
  name: 'PresenceSelector',
  props: {
    variant: {
      type: String,
      default: 'navbar-inline'
    }
  },
  data() {
    return {
      options: PRESENCE_OPTIONS,
      submitting: false
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'token']),
    loggedIn() {
      return !!this.token
    },
    normalized() {
      return normalizePresenceStatus(this.userInfo.presence_status)
    },
    displayLabel() {
      return presenceStatusLabel(this.userInfo.presence_status)
    }
  },
  methods: {
    closePopover() {
      this.$nextTick(() => {
        const pop = this.$refs.popover
        if (pop && typeof pop.doClose === 'function') {
          pop.doClose()
        }
      })
    },
    async onPick(value) {
      if (this.submitting) return
      if (value === this.normalized) {
        this.closePopover()
        return
      }
      this.submitting = true
      try {
        const res = await this.$store.dispatch('user/setPresenceStatus', value)
        if (res && res.code === 1) {
          this.$message.success('状态已更新')
          this.closePopover()
        } else {
          this.$message.error((res && res.msg) || '设置失败')
        }
      } catch (e) {
        this.$message.error('设置失败')
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.presence-ref {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  user-select: none;
  border-radius: 4px;
  transition: background 0.2s;

  &:hover {
    background: rgba(15, 111, 226, 0.08);
  }
}

.presence-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;

  &.dot-online {
    background: #52c41a;
  }

  &.dot-invisible {
    background: #bfbfbf;
  }

  &.dot-busy {
    background: #fa8c16;
  }
}

.variant-navbar-inline {
  .presence-ref {
    padding: 2px 6px;
    margin-left: 2px;
  }

  .presence-label {
    font-size: 12px;
    color: #666;
    font-weight: 500;
  }

  .el-icon-arrow-down {
    font-size: 10px;
    color: #999;
  }
}

.variant-navbar-dropdown {
  .presence-ref {
    padding: 4px 8px;
    margin-top: 6px;
  }

  .presence-label {
    font-size: 14px;
    color: #0f6fe2;
    font-weight: 500;
  }

  .el-icon-arrow-down {
    font-size: 12px;
    color: #0f6fe2;
  }
}

.variant-sidebar {
  .presence-ref {
    padding: 6px 10px;
    justify-content: center;
  }

  .presence-label {
    font-size: 13px;
    color: #606266;
    font-weight: 500;
  }

  .el-icon-arrow-down {
    font-size: 11px;
    color: #909399;
  }
}
</style>

<style lang="scss">
.presence-status-popper {
  padding: 6px 0 !important;
  min-width: 120px;

  .presence-menu {
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      padding: 8px 16px;
      font-size: 14px;
      color: #333;
      cursor: pointer;
      transition: background 0.15s;

      &:hover {
        background: #f5f7fa;
      }

      &.active {
        color: #0f6fe2;
        font-weight: 600;
        background: #ecf5ff;
      }
    }
  }
}
</style>
